import { Component } from '@angular/core';
import { Hire2Link } from '../constants-types';
import { dreamTeamsSelfServeRoutePath } from '../constants-types/Route.constants';
import { SiteNavigationService } from '../core-services/SiteNavigation.service';
import { FeatureFlagsService } from '../system-services';
import { ModuleAccessService } from '../system-services/ModuleAccess/ModuleAccess.service';
@Component({
    selector: 'pi-nav-logo',
    template: `
        @if (!isInDesign) {
            <div
                [piLogo]="{ width: '30px' }"
                [routerLink]="buttonLink"
                tabindex="1"
            ></div>
        }
        @if (isInDesign) {
            <a href="{{ buttonLink }}">
                <div [piLogo]="{ width: '30px' }" tabindex="1"></div>
            </a>
        }
    `,
    standalone: false
})
export class NavigationComponent {
    isInDesign: boolean;
    constructor(
        public siteNavigation: SiteNavigationService,
        private moduleAccess: ModuleAccessService,
        private featureFlags: FeatureFlagsService
    ) {
        this.isInDesign = this.siteNavigation.isInDesign;
    }

    get buttonLink() {
        if (
            this.moduleAccess.isTeamDiscoverySelfServe &&
            this.moduleAccess.hasDesign
        ) {
            return `/design/${dreamTeamsSelfServeRoutePath}`;
        } else if (
            this.siteNavigation.isInHire &&
            this.moduleAccess.isHireHeroSelfServe
        ) {
            return this.siteNavigation.getBaseRoute();
        } else if (this.moduleAccess.isHireHeroSelfServe) {
            /*
             This path shoudn't be reached if hire proxy is enabled.
             Leaving this here in case we rollback Hire proxy and we want the PI nav logo to still route you to the /hire route.
             */
            return `${Hire2Link}`;
        } else {
            return '/dashboard';
        }
    }
}
